/* tslint:disable */
/* eslint-disable */
/**
 * Compliance
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ClientLegalEntityVerificationRequestStatusResource
 */
export interface ClientLegalEntityVerificationRequestStatusResource {
    /**
     * 
     * @type {boolean}
     * @memberof ClientLegalEntityVerificationRequestStatusResource
     */
    canRequestVerification: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof ClientLegalEntityVerificationRequestStatusResource
     */
    hasPendingVerificationRequest: boolean;
    /**
     * The verification status of the legal entity.
     * @type {string}
     * @memberof ClientLegalEntityVerificationRequestStatusResource
     */
    verificationStatus: ClientLegalEntityVerificationRequestStatusResourceVerificationStatusEnum;
}


/**
 * @export
 */
export const ClientLegalEntityVerificationRequestStatusResourceVerificationStatusEnum = {
    IncompleteInfo: 'INCOMPLETE_INFO',
    NotVerified: 'NOT_VERIFIED',
    Pending: 'PENDING',
    Verified: 'VERIFIED'
} as const;
export type ClientLegalEntityVerificationRequestStatusResourceVerificationStatusEnum = typeof ClientLegalEntityVerificationRequestStatusResourceVerificationStatusEnum[keyof typeof ClientLegalEntityVerificationRequestStatusResourceVerificationStatusEnum];


/**
 * Check if a given object implements the ClientLegalEntityVerificationRequestStatusResource interface.
 */
export function instanceOfClientLegalEntityVerificationRequestStatusResource(value: object): value is ClientLegalEntityVerificationRequestStatusResource {
    if (!('canRequestVerification' in value) || value['canRequestVerification'] === undefined) return false;
    if (!('hasPendingVerificationRequest' in value) || value['hasPendingVerificationRequest'] === undefined) return false;
    if (!('verificationStatus' in value) || value['verificationStatus'] === undefined) return false;
    return true;
}

export function ClientLegalEntityVerificationRequestStatusResourceFromJSON(json: any): ClientLegalEntityVerificationRequestStatusResource {
    return ClientLegalEntityVerificationRequestStatusResourceFromJSONTyped(json, false);
}

export function ClientLegalEntityVerificationRequestStatusResourceFromJSONTyped(json: any, ignoreDiscriminator: boolean): ClientLegalEntityVerificationRequestStatusResource {
    if (json == null) {
        return json;
    }
    return {
        
        'canRequestVerification': json['canRequestVerification'],
        'hasPendingVerificationRequest': json['hasPendingVerificationRequest'],
        'verificationStatus': json['verificationStatus'],
    };
}

export function ClientLegalEntityVerificationRequestStatusResourceToJSON(value?: ClientLegalEntityVerificationRequestStatusResource | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'canRequestVerification': value['canRequestVerification'],
        'hasPendingVerificationRequest': value['hasPendingVerificationRequest'],
        'verificationStatus': value['verificationStatus'],
    };
}

